/* Generated from Java with JSweet 2.3.7 - http://www.jsweet.org */
import { Library } from '../../Library';
import { AbstractCommand } from '../AbstractCommand';
import { ModelUtils } from '../util/ModelUtils';
import { LoggerCompat } from '../../compat/LoggerCompat';
import { Document } from '../../core/models/Document';
import { ExtensibleNode } from '../../core/models/ExtensibleNode';
import { Extension } from '../../core/models/Extension';
import { NodePath } from '../../core/models/NodePath';

/**
 * Command that sets an extension.
 * @author eric.wittmann@gmail.com
 * @extends AbstractCommand
 * @class
 */
export class SetExtensionCommand extends AbstractCommand {
    public _parentPath : NodePath;

    public _name : string;

    public _value : any;

    public _hasOldValue : boolean;

    public _oldValue : any;

    public constructor(parent? : any, name? : any, value? : any) {
        if(((parent != null && parent instanceof <any>ExtensibleNode) || parent === null) && ((typeof name === 'string') || name === null) && ((value != null) || value === null)) {
            let __args = arguments;
            super();
            if(this._parentPath===undefined) this._parentPath = null;
            if(this._name===undefined) this._name = null;
            if(this._value===undefined) this._value = null;
            if(this._hasOldValue===undefined) this._hasOldValue = false;
            if(this._oldValue===undefined) this._oldValue = null;
            if(this._parentPath===undefined) this._parentPath = null;
            if(this._name===undefined) this._name = null;
            if(this._value===undefined) this._value = null;
            if(this._hasOldValue===undefined) this._hasOldValue = false;
            if(this._oldValue===undefined) this._oldValue = null;
            (() => {
                this._parentPath = Library.createNodePath(parent);
                this._name = name;
                this._value = value;
            })();
        } else if(parent === undefined && name === undefined && value === undefined) {
            let __args = arguments;
            super();
            if(this._parentPath===undefined) this._parentPath = null;
            if(this._name===undefined) this._name = null;
            if(this._value===undefined) this._value = null;
            if(this._hasOldValue===undefined) this._hasOldValue = false;
            if(this._oldValue===undefined) this._oldValue = null;
            if(this._parentPath===undefined) this._parentPath = null;
            if(this._name===undefined) this._name = null;
            if(this._value===undefined) this._value = null;
            if(this._hasOldValue===undefined) this._hasOldValue = false;
            if(this._oldValue===undefined) this._oldValue = null;
        } else throw new Error('invalid overload');
    }

    /**
     * @see io.apicurio.datamodels.cmd.ICommand#execute(io.apicurio.datamodels.core.models.Document)
     * @param {Document} document
     */
    public execute(document : Document) {
        LoggerCompat.info("[SetExtensionCommand] Executing.");
        this._oldValue = null;
        this._hasOldValue = false;
        let parent : ExtensibleNode = <ExtensibleNode>this._parentPath.resolve(document);
        if(this.isNullOrUndefined(parent)) {
            return;
        }
        let extension : Extension = parent.getExtension(this._name);
        if(ModelUtils.isDefined(extension)) {
            this._hasOldValue = true;
            this._oldValue = extension.value;
            extension.value = this._value;
        } else {
            this._hasOldValue = false;
            this._oldValue = null;
            extension = parent.createExtension();
            extension.name = this._name;
            extension.value = this._value;
            parent.addExtension(this._name, extension);
        }
    }

    /**
     * @see io.apicurio.datamodels.cmd.ICommand#undo(io.apicurio.datamodels.core.models.Document)
     * @param {Document} document
     */
    public undo(document : Document) {
        LoggerCompat.info("[SetExtensionCommand] Reverting.");
        let parent : ExtensibleNode = <ExtensibleNode>this._parentPath.resolve(document);
        if(this.isNullOrUndefined(parent)) {
            return;
        }
        let extension : Extension = parent.getExtension(this._name);
        if(this._hasOldValue && ModelUtils.isDefined(extension)) {
            extension.value = this._oldValue;
        }
        if(!this._hasOldValue && ModelUtils.isDefined(extension)) {
            parent.removeExtension(this._name);
        }
    }
}
SetExtensionCommand["__class"] = "io.apicurio.datamodels.cmd.commands.SetExtensionCommand";
SetExtensionCommand["__interfaces"] = ["io.apicurio.datamodels.cmd.ICommand"];




